<template>
    <form @submit.prevent="submitForm" method="POST" class="mw-360 mx-auto">

        <h3 class="fw-bold text-center">Check your inbox!</h3>
        <p class="text-center my-md">{{ message }}</p>
        <div class="form-field width-100">
            <input type="hidden" name="token" :value="token">
            <input type="hidden" name="source" value="aweber">
            <input
                v-model="code"
                @input="onCodeInput"
                name="code"
                type="text"
                id="code"
                inputmode="numeric"
                placeholder=""
                maxlength="6"
                :disabled="isLoading"
                required
            />
            <label for="code">Code<sup>*</sup></label>

            <div class="alert--input" v-if="error.length">
                {{ error }}
            </div>
        </div>

        <button
            :class="`btn btn--primary btn--full ${buttonDisabled ? 'disabled' : ''}`"
            :disabled="buttonDisabled"
            type="submit"
        >Confirm</button>
        <div v-if="time > 0" class="text-center text-small my-md">
            You can resend via {{ time }}
        </div>
        <div v-else class="text-center text-small my-md">
            <a @click.prevent="resendCode" class="cursor-pointer">Resend Code</a>
        </div>
    </form>
</template>

<script>
import {defineComponent} from 'vue'
import {Exception} from "sass";

export default defineComponent({
    name: "ConfirmOTP",
    data() {
        return {
            code: '',
            message: '',
            token: '',
            error: '',

            isLoading: false, // защита от множественных запросов

            time : 60, // таймер обратного отсчёта сколько секунд осталось до следующей отправки
            timerId: null,
        }
    },

    computed: {
        buttonDisabled() {
            const isCodeValid = this.code.length === 6;

            return this.isLoading || ! isCodeValid;
        }
    },

    mounted() {
        if ( window.authConfirmData ) {
            this.time = window.authConfirmData.time || '';
            this.message = window.authConfirmData.message || '';
            this.token = window.authConfirmData.token || '';
        }

        this.startTimer()
    },

    methods: {
        startTimer() {
            clearInterval( this.timerId );

            this.timerId = setInterval(() => {
                if( this.time > 0 ) {
                    this.time -= 1;
                }
            }, 1000 )

            setTimeout(() => {
                clearInterval( this.timerId );
            }, this.time * 1000);
        },

        onCodeInput( e ) {
            this.validateCode( e.target.value )
        },

        validateCode(inputValue) {
            this.code = inputValue.replace(/\D/g, '').slice(0, 6);

            return (this.code.length === 6);
        },

        async resendCode() {

            if ( this.isLoading ) return;

            this.error = '';

            const payload = {
                action: 'aweber',
                token: this.token
            };

            try {
                const response = await this.$http.post('/auth/code', payload);
                const { status, code, data } = response.data;

                if (status && status === 'error') {
                    this.error = data?.message || 'Unknown error';
                    return;
                }

                if (status && status === 'success') {
                    this.message = data?.message;
                    this.time = data?.time;
                    this.startTimer();
                } else {
                    this.error = data?.message;
                }
            } catch ( err ) {
                console.error('error: ', err)
                // показываем ошибку на странице
            } finally {
                this.isLoading = false
            }
        },

        async submitForm() {

            if (this.buttonDisabled) return;

            this.error = '';

            const payload = {
                action: 'aweber',
                code: this.code,
                token: this.token
            };

            try {
                const response = await this.$http.post('/auth/confirm', payload)

                const { status, code, data } = response.data;

                if( status && status === 'error' ) {
                    this.error = data?.message
                    return;
                }

                if( status && status === 'success' ) {
                    if ( data?.redirect ) {
                        window.location.href = data.redirect;
                    }
                } else {
                    this.error_login = data.message
                }
            } catch (err) {
                console.error('error: ', err)
                // показываем ошибку на странице
            } finally {
                this.isLoading = false
            }
        }
    }
});
</script>

<style scoped>
 .disabled {
    pointer-events: none;
    background-color: #ffe19c;
    border-color: #ffffff;
    opacity: 0.8;
 }
</style>